import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Message } from '../models/message.model';
import { Observable } from 'rxjs';
import { Conversation } from '../models/conversation.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MessagingService {
  private baseUrl = environment.APP_BASE_URL + '/doctor-portal/messaging';

  constructor(private http: HttpClient) {}

  public getMessages(bookingId: string | undefined): Observable<Message[]> {
    return this.http.get<Message[]>(`${this.baseUrl}/messages/booking/${bookingId}`);
  }

  sendMessage(message: Message): Observable<Message> {
    return this.http.post<Message>(`${this.baseUrl}/new/${false}/${message.bookingId}`, message);
  }

  public getConversations(): Observable<Conversation[]> {
    return this.http.get<Conversation[]>(`${this.baseUrl}/conversations`);
  }
}
